<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      国展站<br>
站点介绍<br>
国展站位于大空港片区展城路下方，呈南北向布置，居路中布置。站位以西为国际会展中心。以东为综合配套用地。车站设置有5个出入口，其中C1口为主要紧急出入口,D口为备用紧急出入口。D口为往机场北方向公交接驳口，A口为往会展城方向接驳口。周边有深圳国际会展中心、深圳会展业人民调解委员会等建筑，属国际会展展馆中心地段。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
机场北站	06:59	22:06	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:04	22:04	20号线	7分钟	9分钟-13分26秒<br>
左炮台东	06:25	00:05	12号线	4分钟	8分钟<br>
海上田园东	06:27	23:07	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
机场北站	06:59	22:06	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:04	22:04	20号线	7分钟	9分钟-13分26秒<br>
左炮台东	06:26	00:05	12号线	8分钟	8分钟<br>
海上田园东	06:27	23:07	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
机场北站	06:59	22:06	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:04	22:04	20号线	7分钟	9分钟-13分26秒<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
展城路东侧、展景路西北侧<br><br>
D出入口:<br>
深圳国际会展中心1-8号展馆、展城路西侧、展景路北侧、国展站1公交站、国展站2公交站、国展站3公交站<br><br>
C出入口:<br>
深圳国际会展中心南登陆大厅（9-16号展馆）、展城路西侧、深圳国际会展中心1公交站、深圳国际会展中心2公交站、深圳国际会展中心3公交站、国展站1公交站、国展站2公交站、国展站3公交站<br><br>
公交换乘信息<br><br>
此站暂无数据:<br>
公交站名： 深圳国际会展中心①<br>
会展地铁接驳专线<br><br>
此站暂无数据:<br>
公交站名： 深圳国际会展中心②<br>
B892、M515<br><br>
此站暂无数据:<br>
公交站名：<br>
暂无<br><br>
D出入口:<br>
公交站名： 国展站①<br>
会展地铁接驳专线<br><br>
D出入口:<br>
公交站名： 国展站②<br>
B892、M515<br><br>
D出入口:<br>
公交站名： 国展站③<br>
会展机场接驳专线<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "ershihaoxian",
            title: "20号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>